import styled from "styled-components";

export const Menu = styled.ul`
  margin: 0;
  padding: 0;
  position: fixed;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  height: 50px;
  list-style: none;
  border-bottom: 1px solid #6b7e6c;
  align-items: center;
  background-color: white;
  z-index: 9998;
  transition: height 0.1s ease;

  @media screen and (max-width: 576px) {
    flex-direction: column;
    height: ${(props) => (props.menuOpen ? "200px" : "0px")};
    align-items: flex-start;
    padding: 10px;
    justify-content: ${(props) => (props.menuOpen ? "auto" : "center")};
    margin-top: ${(props) => (props.menuOpen ? "50px" : "0px")};
  }
`;

export const ItemLink = styled.a`
  color: black;
  text-decoration: none;
`;

export const MenuItem = styled.li`
  &:hover {
    text-shadow: 1px 1px 12px rgba(0, 0, 0, 0.59);
  }

  @media screen and (max-width: 576px) {
    display: ${(props) => (props.menuOpen ? "flex" : "none")};
    font-size: 18px;
  }
`;

export const HamburgerIcon = styled.img`
  display: none;
  margin: 5px;
  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 576px) {
    display: inherit;
  }
`;

export const MenuHeaderMobile = styled.div`
  position: fixed;
  display: none;
  background-color: white;
  height: 50px;
  width: 100%;
  z-index: 99999;
  border-bottom: 1px solid gray;

  @media screen and (max-width: 576px) {
    display: flex;
  }
`;
